import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from './../../../../environments/environment';
import { BaseHttpClient } from './base-http-client';

@Injectable()
export class ApiHttpClient extends BaseHttpClient {

    constructor(httpClient: HttpClient) {
        super(httpClient);
        console.log('Creating api http client');
    }

    getUrl(): string { return environment.apiBaseUrl; }

}